
import { Vue, Options } from "vue-class-component";
@Options({
  props: ["timer"]
})
export default class CountDown extends Vue {
  timer!: number;
}
